import { render, staticRenderFns } from "./Instalment.vue?vue&type=template&id=05a39558&scoped=true"
import script from "./Instalment.vue?vue&type=script&lang=js"
export * from "./Instalment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a39558",
  null
  
)

export default component.exports